import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";

import { AuthProvider } from "./lib/auth";
import { ShopProvider } from "./lib/shop";

import { Layout } from "./components/Layout";
import { GeoGate } from "./components/GeoGate";
import { ConsentBanner } from "./components/ConsentBanner";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import Checkout from "./pages/Checkout";
import { Orders, OrderDetail } from "./pages/Orders";
import Account from "./pages/Account";
import { Login, Signup } from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import SellerDashboard from "./pages/SellerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import PrintInvoice from "./pages/PrintInvoice";
import { About, Contact, LegalPage } from "./pages/Static";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const InnerRouter = () => {
  const location = useLocation();
  // Synchronous detection of OAuth callback — must run before normal routes resolve
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/print/:id" element={<PrintInvoice/>} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/product/:idOrSlug" element={<ProductDetail />} />
        {/* Alias: support /products/:slug (singular/plural) */}
        <Route path="/products/:idOrSlug" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/:id" element={<OrderDetail />} />
        <Route path="/account" element={<Account />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        {/* Alias: /register → Signup */}
        <Route path="/register" element={<Signup />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/seller" element={<SellerDashboard />} />
        <Route path="/seller/dashboard" element={<SellerDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/legal/:slug" element={<LegalPage />} />
        {/* Friendly aliases for legally-required policy pages */}
        <Route path="/privacy-policy" element={<LegalPage />} />
        <Route path="/privacy" element={<LegalPage />} />
        <Route path="/terms" element={<LegalPage />} />
        <Route path="/terms-and-conditions" element={<LegalPage />} />
        <Route path="/shipping-policy" element={<LegalPage />} />
        <Route path="/shipping" element={<LegalPage />} />
        <Route path="/returns" element={<LegalPage />} />
        <Route path="/refund-policy" element={<LegalPage />} />
        <Route path="/dpdp" element={<LegalPage />} />
        <Route path="/grievance" element={<LegalPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ShopProvider>
          <GeoGate>
            <InnerRouter />
            <ConsentBanner />
          </GeoGate>
        </ShopProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
